// extracted by mini-css-extract-plugin
module.exports = {"container":"SectionContainer-module__container___2v-VR","content":"SectionContainer-module__content___3AJhR"};